export default __webpack_public_path__ + "static/media/divine_sunderer.9d7effa3.png";